import React, { Component } from "react";
import { Card, CardHeader, CardBody, Col } from "reactstrap";
import parseDate from "../../helpers/parseDate";
import parseTime from "../../helpers/parseTime";
import { CLOUDINARY_SHARE } from "../../helpers/cloudinaryConstants";

class EventItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.gnObject.id !== nextProps.gnObject.id;
  }

  render() {
    const { gnObject, isChild } = this.props;
    return (
      <Col
        xs="12"
        md={isChild ? "12" : "6"}
        style={isChild ? { padding: 0 } : {}}
      >
        <Card>
          <CardHeader>Event</CardHeader>
          <CardBody>
            <h5>Business: {gnObject.business.name}</h5>
            <h6>ID: {gnObject.business.id}</h6>
            <hr />
            {!gnObject.image.isDefault && (
              <img
                style={{ width: "50%" }}
                src={`${CLOUDINARY_SHARE}/${gnObject.image.image.cloudinaryId}`}
              />
            )}
            <p>{gnObject.name}</p>
            <p>{gnObject.description}</p>
            <p>
              <span style={{ fontWeight: "bold " }}>Start: </span>
              {parseDate(gnObject.startAt)} at {parseTime(gnObject.startAt)}
            </p>
            <p>
              <span style={{ fontWeight: "bold " }}>End: </span>
              {parseDate(gnObject.endAt)} at {parseTime(gnObject.endAt)}
            </p>
          </CardBody>
          {this.props.children}
        </Card>
      </Col>
    );
  }
}

export default EventItem;



// WEBPACK FOOTER //
// ./src/views/Components/EventItem.js